import { createRef, Fragment, Component } from 'react';

export default class NavbarReplacer extends Component {
  constructor(props) {
    super(props);
    this.navRef = createRef();
    this.blob = createRef();
    this.didScroll = false;
    this.navbar = $('.header-wrapper');
    this.window = $(window);
    this.body = $('body');
    this.animation = null;
  }

  componentDidMount() {
    if (this.navbar.length && $(this.navRef.current).is(':visible')) {
      this.setOtherVariables();
      this.replaceNavbarOnScroll();
      this.windowScrollListener();
    }
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animation);
  }

  windowScrollListener() {
    this.window.on('scroll', () => {
      this.didScroll = true;
    });
  }

  setOtherVariables() {
    this.$navRef = $(this.navRef.current);
    this.$blob = $(this.blob.current);
    this.navHeight = this.navbar.outerHeight();
    this.navbarVisible = true;
    this.navSwitched = false;
    this.navRefTop = this.$navRef.position().top;
    this.navRefHeight = this.$navRef.outerHeight();
  }

  replaceNavbarOnScroll() {
    let runAnimation = () => {
      this.animation = requestAnimationFrame(runAnimation);
      if (!this.didScroll) return;
      if (!this.navSwitched) this.navRefTop = this.$navRef.position().top;

      let windowScrollTop = this.window.scrollTop();
      // navbar
      if (windowScrollTop + this.navHeight >= this.navRefTop) {
        this.navSwitched = true;
        this.navbar.css({
          position: 'absolute',
          top: this.navRefTop - this.navHeight,
        });
        this.navbarVisible = false;
      } else if (windowScrollTop + this.navHeight < this.navRefTop) {
        this.navSwitched = false;
        this.navbar.css({ position: 'fixed', top: 0 });
        this.navbarVisible = true;
      }

      // links container
      if (windowScrollTop >= this.navRefTop) {
        // adds body padding to prevent snapping
        this.$blob.css({ 'padding-top': this.navRefHeight });
        this.$navRef.css({
          position: 'fixed',
          top: 0,
          'z-index': 200,
        });
      } else if (windowScrollTop < this.navRefTop) {
        this.$blob.css({ 'padding-top': 0 });
        this.$navRef.css({
          position: 'initial',
          top: 0,
          'z-index': 'initial',
        });
      }
      this.didScroll = false;
    };
    runAnimation();
  }

  render() {
    return (
      <Fragment>
        <div ref={this.blob} className="navbar-replacer-blob"></div>
        <div ref={this.navRef} className="navbar-replacer">
          {this.props.children}
        </div>
      </Fragment>
    );
  }
}
